






















































































































































import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import DefaultSpecificationValue from '~/components/car/classifieds/view/partials/Specifications/DefaultSpecificationValue.vue'
import CategorySpecification from '~/components/car/classifieds/view/partials/Specifications/CategorySpecification.vue'
import PriceSpecification from '~/components/car/classifieds/view/partials/Specifications/PriceSpecification.vue'
import FuelConsumptionSpecification from '~/components/car/classifieds/view/partials/Specifications/FuelConsumptionSpecification.vue'
import LinkSpecification from '~/components/car/classifieds/view/partials/Specifications/LinkSpecification.vue'
import RegistrationSpecification from '~/components/car/classifieds/view/partials/Specifications/RegistrationSpecification.vue'
import ParkedSpecification from '~/components/car/classifieds/view/partials/Specifications/ParkedSpecification.vue'
import { Specification } from '~/models/classified/types'
import LeasingSpecification from '~/components/car/classifieds/view/partials/Specifications/LeasingSpecification.vue'
import GoToConcactSpecification from '~/components/car/classifieds/view/partials/Specifications/GoToConcactSpecification.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import {
  computed,
  defineComponent,
  defineVue3AsyncComponent,
  toRefs
} from '~/utils/nuxt3-migration'
import { copyTextToClipboard } from '~/utils/dom'
import { ciCopy } from '~/icons/source/regular/copy'
import { useNamespacedStore } from '~/compositions/store'
import { useSnackbar } from '~/compositions/snackbar'
import { useI18n } from '~/compositions/i18n'
import { defineComponentTranslations } from '~/utils/i18n'
import { ciInfoCircle } from '~/icons/source/regular/info-circle'
import { useUserAgent } from '~/compositions/user-agent'

export default defineComponent({
  components: {
    CExpandableContent,
    CCard,
    GoToConcactSpecification,
    CategorySpecification,
    ForMakeModelSpecification: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/Specifications/ForMakeModelSpecification.vue'
      )
    ),
    DefaultSpecificationValue,
    ExtraTelephoneSpecification: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/Specifications/custom/ExtraTelephoneSpecification'
      )
    ),
    FinanceSpecification: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/Specifications/FinanceSpecification.vue'
      )
    ),
    PriceSpecification,
    FuelConsumptionSpecification,
    LinkSpecification,
    RegistrationSpecification,
    OfferTypeSpecification: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/Specifications/OfferTypeSpecification.vue'
      )
    ),
    ParkedSpecification,
    LeasingSpecification
  },
  props: {
    specifications: { type: Array, required: true },
    extraSpecifications: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    categoryId: { type: Number, required: false, default: null },
    jobsLayout: { type: Boolean, required: false, default: false },
    withoutCard: { type: Boolean, required: false, default: false },
    preExpanded: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { specifications, extraSpecifications } = toRefs(props)
    const {
      state: classifiedViewState,
      getters: classifiedViewGetters
    } = useNamespacedStore<ClassifiedViewState>(CLASSIFIED_VIEW_NS)
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const { isMobile } = useUserAgent()
    const snackbar = useSnackbar()
    const { t } = useI18n()

    const userIsAdmin = computed(() => userGetters('isAdmin'))

    const isPartClassified = computed(() =>
      classifiedViewGetters('isPartClassified')
    )
    const isXymaClassified = computed(() =>
      classifiedViewGetters('isXymaClassified')
    )
    const sellerOnlyContactViaMessages = computed(() =>
      classifiedViewGetters('sellerOnlyContactViaMessages')
    )

    const classifiedId = computed(() => classifiedViewState.classified?.id)
    const seller = computed(() => classifiedViewState.seller)

    const allPhones = computed(() => {
      const allPhones = []
      if (seller.value.extra_telephone || seller.value.telephone1) {
        allPhones.push({
          value: seller.value.extra_telephone || seller.value.telephone1,
          extra_name: seller.value.extra_name || null
        })
      }
      if (seller.value.telephone2) {
        allPhones.push({
          value: { ...seller.value.telephone2, social: null }
        })
      }
      if (seller.value.mobile) {
        allPhones.push({
          value: { ...seller.value.mobile, social: null }
        })
      }

      return allPhones
    })

    const allSpecifications = computed<Specification[]>(() => {
      const hardcodedSpecifications = [] // use this to add hardcoded specs

      if (userIsAdmin.value) {
        if (seller.value.extra_telephone || seller.value.telephone1) {
          const telephoneSpec = {
            name: 'telephone',
            label: t('telephone')
          }
          hardcodedSpecifications.push(telephoneSpec)
        }

        if (sellerOnlyContactViaMessages.value) {
          const telephoneSpec = {
            name: 'message-only',
            label: t('telephone')
          }
          hardcodedSpecifications.push(telephoneSpec)
        }
      }
      return [
        ...(specifications.value.filter(
          s => s.name && (s.value || s.value === 0)
        ) as any[]),
        ...(extraSpecifications.value.filter(
          s => s.name && (s.value || s.value === 0)
        ) as any[]),
        ...(hardcodedSpecifications as any)
      ].filter(specification => {
        return specification.value !== null
      })
    })

    function onCopyClassifiedId() {
      copyTextToClipboard(classifiedViewState?.classifiedId)
      snackbar.success(t('classified_id_was_copied'))
    }

    function getExtraInfo(specification) {
      if (specification.extra_info) {
        return specification.extra_info
      }

      if (specification.name === 'registration') {
        return t(
          'please make sure that the listed registration is the date of the first declaration, e.g. if it was registered abroad then that is the valid date.'
        )
      }
      return null
    }

    return {
      onCopyClassifiedId,
      ciCopy,
      ciInfoCircle,
      isPartClassified,
      isXymaClassified,
      sellerOnlyContactViaMessages,
      classifiedId,
      seller,
      isMobile,
      userIsAdmin,
      allPhones,
      allSpecifications,
      getExtraInfo
    }
  },
  i18n: defineComponentTranslations({
    classified_id_was_copied: {
      en: 'The classified id was copied',
      el: 'Ο αριθμός αγγελίας αντιγράφηκε'
    }
  })
})
